export default __webpack_public_path__ + "static/media/clusters.65d0ea84.svg";